import type { FieldValues } from "react-hook-form";

import { ComboboxField, type ComboboxFieldProps } from "./ComboboxField";
import { COUNTRY_OPTIONS } from "./countries";

type Props<T extends FieldValues> = Omit<
  ComboboxFieldProps<T>,
  "options" | "searchPlaceholder" | "emptyText"
> & { options?: ReadonlyArray<string> };

/** Searchable country picker over the shared country list. */
export function CountryField<T extends FieldValues>({
  options = COUNTRY_OPTIONS,
  placeholder = "Select country",
  ...rest
}: Props<T>) {
  return (
    <ComboboxField
      {...rest}
      options={options}
      placeholder={placeholder}
      searchPlaceholder="Search countries…"
      emptyText="No country found."
    />
  );
}
